import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';

function useClipboard() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2e3 : _ref$timeout;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      copied = _useState4[0],
      setCopied = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      copyTimeout = _useState6[0],
      setCopyTimeout = _useState6[1];

  var handleCopyResult = function handleCopyResult(value) {
    clearTimeout(copyTimeout);
    setCopyTimeout(setTimeout(function () {
      return setCopied(false);
    }, timeout));
    setCopied(value);
  };

  var copy = function copy(valueToCopy) {
    if ("clipboard" in navigator) {
      navigator.clipboard.writeText(valueToCopy).then(function () {
        return handleCopyResult(true);
      }).catch(function (err) {
        return setError(err);
      });
    } else {
      setError(new Error("useClipboard: navigator.clipboard is not supported"));
    }
  };

  var reset = function reset() {
    setCopied(false);
    setError(null);
    clearTimeout(copyTimeout);
  };

  return {
    copy: copy,
    reset: reset,
    error: error,
    copied: copied
  };
}

export { useClipboard };